import { useState } from "react";
import { NotchSegmented } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const Building = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 21v-4h6v4" />
  </svg>
);
const Globe = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18" />
  </svg>
);

/**
 * Verification harness for NotchSegmented. Verify in a real browser (shape()
 * clip): the selected segment is a notched accent fill inside the notched track,
 * the keyline traces the notch, and arrow keys move the selection.
 */
export function NotchSegmentedDemo() {
  const [scope, setScope] = useState("workspace");
  const [mode, setMode] = useState("fast");
  const [s, setS] = useState("a");

  return (
    <Section
      id="notch-segmented"
      title="NotchSegmented"
      description="A controlled segmented selector in the notch language — the app's This-Workspace/All-Workspaces and Fast/Pro toggles. A notched track (nx-rim keyline) holds the options; the selected one is a notched accent segment (nx-t + --primary). Radio semantics + roving arrow-key focus. Sizes sm/default/lg; options take an optional icon. Token-driven."
    >
      <VariantBlock label="The real toggles" caption="scope (with icons) · mode">
        <div className="flex flex-wrap items-center gap-5">
          <NotchSegmented
            aria-label="Studio scope"
            value={scope}
            onValueChange={setScope}
            options={[
              { value: "workspace", label: "This Workspace", icon: <Building /> },
              { value: "org", label: "All Workspaces", icon: <Globe /> },
            ]}
          />
          <NotchSegmented
            aria-label="Model mode"
            value={mode}
            onValueChange={setMode}
            options={[
              { value: "fast", label: "Fast" },
              { value: "pro", label: "Pro" },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Size — sm · default · lg" caption="three options">
        <div className="flex flex-col items-start gap-3">
          {(["sm", "default", "lg"] as const).map((sz) => (
            <NotchSegmented
              key={sz}
              size={sz}
              aria-label={`size ${sz}`}
              value={s}
              onValueChange={setS}
              options={[
                { value: "a", label: "Day" },
                { value: "b", label: "Week" },
                { value: "c", label: "Month" },
              ]}
            />
          ))}
        </div>
      </VariantBlock>
    </Section>
  );
}
